import { Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ChartOptions, ChartType } from "chart.js";
import { Label, monkeyPatchChartJsLegend, monkeyPatchChartJsTooltip, SingleDataSet } from "ng2-charts";
import { ActivatedRoute, Router } from "@angular/router";
import { CourseService } from "../../shared/services/course.service";
import { ErrorHandlerService } from "../../shared/services/error-handler.service";
import { GlobalService } from 'src/app/shared/services/global.service';
import { AdminService } from 'src/app/shared/services/admin.service';
import { ConfirmationService } from 'primeng/api';
import { Chart } from "chart.js";
import { QuizServiceService } from 'src/app/shared/services/quiz-service.service';
import { SelfAssessmentStateService } from 'src/app/shared/services/self-assessment-state.service';

@Component({
  selector: 'app-assessment-report',
  templateUrl: './assessment-report.component.html',
  styleUrls: ['./assessment-report.component.scss']
})
export class AssessmentReportComponent implements OnInit, OnDestroy {
  // @ts-ignore
  subscriptions: Subscription = [];
  isDemo = false;

  totalCorrect = 0;
  totalIncorrect = 0;
  totalOmitted = 0;
  totalQuizzes = 0;
  quizCompleted = 0;
  quizSuspended = 0;
  corr_corr = 0;
  corr_incorr = 0;
  incorr_incorr = 0;
  incorr_corr = 0;
  bestSubject: any;
  worstSubject: any;
  ifAdmin = false;
  subscribedCourses: any = [];
passingPercentage=0;
  contentLoader = false;
  basicData: any;
  basicOptions: any;
  courseId: any = [];

  userGraph:any;
  pointersColorClasses = ['eup-green-pointer', 'eup-red-pointer', 'eup-blue-pointer', 'eup-purple-pointer'];

  chartType: ChartType = 'pie';
  pieChartOptions: ChartOptions = {
    responsive: true,
  };
  chartColors: Array<any> = [
    {
      backgroundColor: [
        '#61ce87',
        '#e14f6a',
        '#389cf2',
        '#7583f0'
      ]
    }
  ];

  pieChartLabels: Label[] = [['Correct to Correct'], ['Correct to Incorrect'], ['Incorrect to Correct'], ['Incorrect to Incorrect']];
  pieChartData: SingleDataSet = [20, 16, 36, 40];
  pieChartType: ChartType = 'pie';
  pieChartLegend = false;
  pieChartPlugins = [];
  cardLabels = [
    { label: 'Correct to Correct', value: 12, bgClass: 'eup-green-card' },
    { label: 'Correct to Incorrect', value: 2, bgClass: 'eup-red-card' },
    { label: 'Incorrect to Correct', value: 14, bgClass: 'eup-blue-card' },
    { label: 'Incorrect to Incorrect', value: 20, bgClass: 'eup-purple-card' },
  ];

  pieChartLabels1: Label[] = [['Total Questions'], ['Used  Questions'], ['Unused Questions']];
  pieChartData1: SingleDataSet = [];
  cardLabels1 = [
    { label: 'Total Questions', value: 12, bgClass: 'eup-green-card' },
    { label: 'Used Questions', value: 2, bgClass: 'eup-red-card' },
    { label: 'Unused Questions', value: 14, bgClass: 'eup-blue-card' }
  ];

  totalCorrectPercentage: any = 40;
  totalUsedPercentage: any = 20;

  tooltipContent = "You got a score that is higher than 80% of course subscribers and 20% of course subscribers got a score that is higher than your score.";

  isPeerLoaded = false;
  isCategoryLoaded = false;

  // Bell curve related properties
  userRank = 0;
  peerRank = 0;
  xUserValue = 0;
  yUserValue = 0;
  xPeerValue = 0;
  avgQuizScore = 0;
  avgPeerQuizScore = 0;
  peerLoader = false;

  innerWidth: any;
  @HostListener('window:resize', ['$event'])

  barData: any;
  barOptions: any;

  selectedCategory = 'Subject';
  categories: any = [];
  myScores: any = [];
  peerScores: any = [];
  allCategories: any = [];
  tempCategories: any = [];

  @ViewChild('myChart') barChart: Chart;
  loader = false;
  loaderValue = 0;

  paginationValue = 0;

  performanceOptions = ['Overall', 'Analysis'];
  selectedOption = 'Overall';
  totalQuestions = 0;
  selectAssessment:any;
  assesmentsList=[]
  chanceOfPassing = 0; // Value between 0-100
  threedigitScore = 0;

  constructor(
    private quizService: QuizServiceService,
    private confirmationService: ConfirmationService,
    private adminService: AdminService,
    private globalService: GlobalService,
    private route: ActivatedRoute,
    private router: Router,
    private courseService: CourseService,
    private errorHandler: ErrorHandlerService,
    private selfAssessmentStateService: SelfAssessmentStateService
  ) {
    this.setupSecurityListeners();
  }

  ngOnInit(): void {
    this.initializeComponent();

    this.getAllAssessments();

  }

  ngOnDestroy(): void {
    document.removeEventListener('contextmenu', this.removeMouseOptions);
    document.onkeydown = null;
    this.subscriptions.forEach(item => item.unsubscribe());
  }

  getSelfAssessmentReporting()
  {
    this.loader=true;
    this.subscriptions.push(
      this.courseService.getSelfAssessmentReporting({userId: parseInt(localStorage.getItem('Id')), assessmentId: this.selectAssessment}).subscribe((res: any) => {
        console.log(res);
        this.totalCorrect = res.data.totalCorrectQuestions;
        this.totalIncorrect = res.data.totalIncorrectQuestions;
        this.totalOmitted = res.data.totalOmittedQuestions;
        this.corr_corr = res.data.totalCorrect_Correct;
        this.corr_incorr = res.data.totalCorrect_Incorrect;
        this.incorr_corr = res.data.totalIncorrect_Correct;
        this.incorr_incorr = res.data.totalIncorrect_Incorrect;
    this.passingPercentage = res.data.passingScore;
        this.cardLabels[0].value = this.corr_corr;
        this.cardLabels[1].value = this.corr_incorr;
        this.cardLabels[2].value = this.incorr_corr;
        this.cardLabels[3].value = this.incorr_incorr;
        this.userGraph = res.data.userGraph;
        this.userRank = res.data.userRank.toFixed(2);
        this.peerRank = res.data.peerRank.toFixed(2);
       
        this.avgQuizScore = res.data.avgQuizScore.toFixed(2);
        this.avgPeerQuizScore = res.data.avgQuizPeerScore.toFixed(2);

        this.threedigitScore = res.data.threedigitScore;

        // Calculate chance of passing based on correct answers percentage
        const totalAnswered = this.totalCorrect + this.totalIncorrect + this.totalOmitted;
        this.chanceOfPassing = totalAnswered > 0 ? (this.totalCorrect / totalAnswered) * 100 : 0;

        this.calculateGraphPositions();
        
        this.loader=false;
      })
    );
  }
  private setupSecurityListeners() {
    document.addEventListener('contextmenu', this.removeMouseOptions);
    document.onkeydown = this.handleKeyboardShortcuts;
  }

  private handleKeyboardShortcuts = (e: KeyboardEvent) => {
    if (e.keyCode === 123) return false;
    if (e.ctrlKey && e.key === 'E') return false;
    if (e.ctrlKey && e.shiftKey && e.key === 'I') return false;
    if (e.ctrlKey && e.shiftKey && e.key === 'J') return false;
    if (e.ctrlKey && e.key === 'U') return false;
    if (e.ctrlKey && e.key === 'S') return false;
    if (e.ctrlKey && e.key === 'H') return false;
    if (e.ctrlKey && e.key === 'A') return false;
    if (e.ctrlKey && e.key === 'F') return false;
    return true;
  }

  removeMouseOptions(e: any) {
    e.preventDefault();
  }

  private initializeComponent() {
    this.loadSubscribedCourses();
    this.setupWindowSize();
    this.setupAdminStatus();
    this.initializeCharts();
    this.loadInitialData();
  }

  private loadSubscribedCourses() {
    if (localStorage.getItem('subscriptions')) {
      this.subscribedCourses = JSON.parse(localStorage.getItem('subscriptions'));
      this.courseId = this.subscribedCourses.map((item: any) => item.courseID);
      this.totalQuestions = this.subscribedCourses
        .map((item: any) => item.courseQuestions)
        .reduce((sum: any, value: any) => sum + value, 0);
    }
  }

  private setupWindowSize() {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth > 750) {
      document.getElementById('eup-navbar-heading').innerText = 'Assessment Report';
    } else {
      document.getElementById('eup-navbar-heading').innerText = '';
    }
  }

  private setupAdminStatus() {
    if (localStorage.getItem("ifAdmin")) {
      this.ifAdmin = JSON.parse(localStorage.getItem("ifAdmin"));
    }
  }

  private initializeCharts() {
    monkeyPatchChartJsTooltip();
    monkeyPatchChartJsLegend();
    this.generateBarChart();
  }

  private loadInitialData() {
    if (localStorage.getItem('Id') === '-1') {
      this.isDemo = true;
      this.getDemoValues();
    }
  }

  onResize(event: any) {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth < 750) {
      document.getElementById('eup_username').innerText = '';
      document.getElementById('eup-navbar-heading').innerText = '';
    }
  }

  calculateGraphPositions() {
    this.xUserValue = 4.36 * this.userRank;
    this.xPeerValue = 4.36 * this.peerRank;

    let value = 0;
    let greater = this.userRank > 50;

    console.log(this.userRank)

    if (this.userRank >= 0 && this.userRank < 5) {
      value = this.userRank - 0;
      this.yUserValue = 203 - (value * 1);
    } else if (this.userRank >= 5 && this.userRank < 10 || this.userRank > 95 && this.userRank <= 100) {
      if (greater) {
        value = this.userRank - 95;
        this.yUserValue = 198 + (value * 1);
      } else {
        value = this.userRank - 5;
        this.yUserValue = 198 - (value * 3);
      }
    }
    else if (this.userRank >= 10 && this.userRank < 15 || this.userRank > 90 && this.userRank <= 95) {
      if (greater) {
        value = this.userRank - 90;
        this.yUserValue = 181 + (value * 3);
      }
      else {
        value = this.userRank - 10;
        this.yUserValue = 181 - (value * 5);
      }
    }
    else if (this.userRank >= 15 && this.userRank < 20 || this.userRank > 85 && this.userRank <= 90) {
      if (greater) {
        value = this.userRank - 85;
        this.yUserValue = 156 + (value * 5);
      }
      else {
        value = this.userRank - 15;
        this.yUserValue = 156 - (value * 6);
      }
    }
    else if (this.userRank >= 20 && this.userRank < 25 || this.userRank > 80 && this.userRank <= 85) {
      if (greater) {
        value = this.userRank - 80;
        this.yUserValue = 126 + (value * 6);
      }
      else {
        value = this.userRank - 20;
        this.yUserValue = 126 - (value * 6);
      }
    }
    else if (this.userRank >= 25 && this.userRank < 30 || this.userRank > 75 && this.userRank <= 80) {
      if (greater) {
        value = this.userRank - 75;
        this.yUserValue = 96 + (value * 6);
      }
      else {
        value = this.userRank - 25;
        this.yUserValue = 96 - (value * 5);
      }
    }
    else if (this.userRank >= 30 && this.userRank < 35 || this.userRank > 70 && this.userRank <= 75) {
      if (greater) {
        value = this.userRank - 70;
        this.yUserValue = 71 + (value * 5);
      }
      else {
        value = this.userRank - 30;
        this.yUserValue = 71 - (value * 5);
      }
    }
    else if (this.userRank >= 35 && this.userRank < 40 || this.userRank > 65 && this.userRank <= 70) {
      if (greater) {
        value = this.userRank - 65;
        this.yUserValue = 46 + (value * 5);
      }
      else {
        value = this.userRank - 35;
        this.yUserValue = 46 - (value * 3);
      }
    }
    else if (this.userRank >= 40 && this.userRank < 45 || this.userRank > 60 && this.userRank <= 65) {
      if (greater) {
        value = this.userRank - 60;
        this.yUserValue = 31 + (value * 3);
      }
      else {
        value = this.userRank - 40;
        this.yUserValue = 31 - (value * 3);
      }
    }
    else if (this.userRank >= 45 && this.userRank < 50 || this.userRank > 55 && this.userRank <= 60) {
      if (greater) {
        value = this.userRank - 55;
        this.yUserValue = 16 + (value * 3);
      }
      else {
        value = this.userRank - 45;
        this.yUserValue = 16 - (value * 1);
      }
    }
    else if (this.userRank == 50 || this.userRank > 50 && this.userRank <= 55) {
      value = this.userRank - 50;
      if (greater) {
        this.yUserValue = 11 + (value * 1);
      }
      else {
        this.yUserValue = 11;
      }
    }
  }
  getAssessmentReport()
  {
    
    this.getSelfAssessmentReporting();
  }

  generateBarChart() {
    this.barData = {
      labels: this.categories,
      datasets: [
        {
          backgroundColor: '#D2D5DD',
          hoverBackgroundColor: '#D2D5DD',
          borderColor: '#D2D5DD',
          barThickness: 20,
          data: this.myScores
        },
        {
          backgroundColor: '#61ce87',
          hoverBackgroundColor: '#61ce87',
          borderColor: '#61ce87',
          barThickness: 20,
          data: this.peerScores
        }
      ]
    };

    this.barOptions = {
      legend: {
        display: false
      },
      scales: {
        xAxes: [{
          ticks: {
            color: '#495057'
          }
        }],
        yAxes: [{
          ticks: {
            color: '#495057',
            beginAtZero: true,
            steps: 10,
            stepValue: 1,
            max: 100
          }
        }]
      }
    };
  }

  makeGraph(peerAvgScore: any, avgScore: any) {
    let backgroundColor: any;
    let backgroundColor1: any;

    if (avgScore >= 55) {
      backgroundColor1 = 'rgba(92, 166, 239,.5)';
      backgroundColor = 'rgba(134, 207, 131,.5)';
    } else {
      backgroundColor1 = 'rgba(92, 166, 239,.5)';
      backgroundColor = 'rgb(237, 28, 36,.5)';
    }

    this.basicData = {
      labels: ["Peer", "You", ''],
      datasets: [
        {
          barPercentage: 0.5,
          borderRadius: 10,
          label: "Current Score Overall",
          opacity: .6,
          data: [peerAvgScore, avgScore, 0],
          backgroundColor: [backgroundColor1, backgroundColor]
        },
        {
          type: 'line',
          label: "Passing Peer Average",
          borderColor: '#86CF83',
          data: [50, 50, 50],
          fill: false
        }
      ]
    };

    this.basicOptions = {
      legend: { display: false },
      gridLines: { display: false },
      title: { display: false },
      scales: {
        yAxes: [{
          display: true,
          scaleLabel: { show: false },
          ticks: {
            beginAtZero: true,
            stepSize: 50,
            max: 100,
            min: 0
          }
        }],
        xAxes: [{
          lineThickness: 0,
          ticks: {
            display: true,
            beginAtZero: 0
          }
        }]
      }
    };
  }

  getDemoValues() {
    this.subscribedCourses = ['Free Trail'];
    this.bestSubject = 'Pharmacology';
    this.worstSubject = 'Medicine';
    this.totalCorrect = 5;
    this.totalIncorrect = 2;
    this.totalOmitted = 3;
    this.totalQuizzes = 3;
    this.quizCompleted = 2;
    this.quizSuspended = 1;
    this.pieChartData = [3, 2, 3, 2];
    this.corr_corr = 3;
    this.corr_incorr = 2;
    this.incorr_corr = 3;
    this.incorr_incorr = 2;
    this.cardLabels[0].value = this.corr_corr;
    this.cardLabels[1].value = this.corr_incorr;
    this.cardLabels[2].value = this.incorr_corr;
    this.cardLabels[3].value = this.incorr_incorr;
    this.totalCorrectPercentage = 60;
    this.totalUsedPercentage = 80;

    this.pieChartData1 = [10, 8, 2];
    this.cardLabels1[0].value = 10;
    this.cardLabels1[1].value = 8;
    this.cardLabels1[2].value = 2;
    this.makeGraph(55.1, 65.3);
  }

  private updateStatsFromResponse(res: any) {
    this.totalCorrect = res.totalCorrectQuestions;
    this.totalIncorrect = res.totalIncorrectQuestions;
    this.totalOmitted = res.totalOmittedQuestions;
    this.totalQuizzes = res.totalQuizzes;
    this.quizCompleted = res.totalCompletedQuizzes;
    this.quizSuspended = res.totalSuspendedQuizzes;
    
    this.updatePieChartData(res);
    this.updatePercentages(res);
    this.updateUsageData(res);
  }

  private updatePieChartData(res: any) {
    this.pieChartData = [
      res.totalCorrect_Correct,
      res.totalCorrect_Incorrect,
      res.totalIncorrect_Correct,
      res.totalIncorrect_Incorrect
    ];
    
    this.corr_corr = res.totalCorrect_Correct;
    this.corr_incorr = res.totalCorrect_Incorrect;
    this.incorr_corr = res.totalIncorrect_Correct;
    this.incorr_incorr = res.totalIncorrect_Incorrect;

    this.cardLabels[0].value = this.corr_corr;
    this.cardLabels[1].value = this.corr_incorr;
    this.cardLabels[2].value = this.incorr_corr;
    this.cardLabels[3].value = this.incorr_incorr;
  }

  private updatePercentages(res: any) {
    this.totalCorrectPercentage = ((this.totalCorrect / (this.totalCorrect + this.totalIncorrect + this.totalOmitted)) * 100).toFixed(1);
    if (this.totalCorrectPercentage > 100) {
      this.totalCorrectPercentage = 100;
    }

    this.totalUsedPercentage = ((res.totalUsedQuestions / this.totalQuestions) * 100).toFixed(1);
    if (this.totalUsedPercentage > 100) {
      this.totalUsedPercentage = 100;
    }
  }

  private updateUsageData(res: any) {
    this.pieChartData1 = [
      this.totalQuestions,
      res.totalUsedQuestions,
      this.totalQuestions - res.totalUsedQuestions
    ];
    
    this.cardLabels1[0].value = this.totalQuestions;
    this.cardLabels1[1].value = res.totalUsedQuestions;
    this.cardLabels1[2].value = this.totalQuestions - res.totalUsedQuestions;
  }

  handleSingleCourse(courseId: any) {
    
    this.totalQuestions = this.subscribedCourses[
      this.subscribedCourses.findIndex((item: any) => item.courseID == courseId)
    ].courseQuestions;
    this.courseId = [courseId];

    // get the assessment list from the database. 

    this.getAllAssessments();
    // this.getPerformanceStats();
  }


  async getAllAssessments()
  {
  try {

    this.loader=true;
    this.courseId = this.courseId[0];
  
        const response: any = await this.quizService.getSelfAssessmentList( this.courseId ).toPromise();
        this.assesmentsList = response.data.selfAssessments;

        if (this.assesmentsList.length>0) {
          // Check if we have a saved assessment selection that exists in the current list
          const savedState = this.selfAssessmentStateService.getState();
          let hasValidSavedAssessment = false;
          
          if (savedState && savedState.selectAssessment) {
            // Check if the saved assessment exists in the current list
            const savedAssessmentExists = this.assesmentsList.find(
              assessment => assessment.assessment_id === savedState.selectAssessment
            );
            
            if (savedAssessmentExists) {
              this.selectAssessment = savedState.selectAssessment;
              hasValidSavedAssessment = true;
            }
          }
          
          // If no valid saved assessment, use the first one
          if (!hasValidSavedAssessment) {
            this.selectAssessment = this.assesmentsList[0].assessment_id;
          }

          this.getSelfAssessmentReporting();
        }
      } catch (error) {
        this.errorHandler.handleError(error);
      }
    
  }
  changeOption(option: string) {
    this.selectedOption = option;
    if (option === 'Analysis') {
      this.loader = true;
      // Reset any existing data
      this.categories = [];
      this.myScores = [];
      this.peerScores = [];
      this.allCategories = [];
      this.tempCategories = [];
      
      // Get analysis data
      this.subscriptions.push(
        this.courseService.getAnalysisStats(this.courseId).subscribe((res: any) => {
          this.loader = false;
          if (res && res.length > 0) {
            this.processAnalysisData(res);
          }
        }, error => {
          this.loader = false;
          this.errorHandler.handleError(error);
        })
      );
    }
  }

  private processAnalysisData(data: any) {
    this.allCategories = data;
    this.tempCategories = [...data];
    this.updateChartData();
  }

  private updateChartData() {
    this.categories = this.tempCategories.map(item => item.categoryName);
    this.myScores = this.tempCategories.map(item => item.userScore);
    this.peerScores = this.tempCategories.map(item => item.peerScore);
    this.generateBarChart();
  }
}
